import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/format";

interface Alert {
  _id: string;
  type: string;
  severity: "INFO" | "WARNING" | "CRITICAL";
  message: string;
  symbol?: string;
  acknowledged: boolean;
  createdAt: string;
}

export default function Alerts() {
  const { data: alertsResp, isLoading, error } = useQuery<{ data: Alert[] }>({
    queryKey: ["alerts"],
    queryFn: () => api.get("/alerts"),
  });
  const alerts = alertsResp?.data ?? [];

  const severityColor = (s: string) => {
    switch (s) {
      case "CRITICAL": return "var(--red-light)";
      case "WARNING": return "var(--amber)";
      default: return "var(--primary-light)";
    }
  };

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>
        Alerts
      </h1>

      <div className="card">
        {isLoading && <div style={{ padding: 20, color: "var(--text-muted)" }}>Loading alerts…</div>}
        {error && <div style={{ padding: 20, color: "var(--red-light)" }}>Error: {error.message}</div>}
        {alerts && alerts.length === 0 && (
          <div style={{ padding: 20, color: "var(--text-muted)" }}>No alerts</div>
        )}
        {alerts && alerts.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Severity</th>
                <th>Type</th>
                <th>Symbol</th>
                <th>Message</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {alerts.map((a) => (
                <tr key={a._id}>
                  <td style={{ fontSize: 12, color: "var(--text-muted)", whiteSpace: "nowrap" }}>
                    {formatDateTime(a.createdAt)}
                  </td>
                  <td>
                    <span style={{ fontSize: 11, fontWeight: 700, color: severityColor(a.severity), textTransform: "uppercase" }}>
                      {a.severity}
                    </span>
                  </td>
                  <td style={{ fontSize: 13 }}>{a.type}</td>
                  <td style={{ fontWeight: 500 }}>{a.symbol || "—"}</td>
                  <td style={{ fontSize: 13 }}>{a.message}</td>
                  <td>
                    <span style={{ fontSize: 11, color: a.acknowledged ? "var(--text-muted)" : "var(--amber)" }}>
                      {a.acknowledged ? "ACK" : "NEW"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
